export default function ProgressionSelect({
  graus = [],
  options,
  onChange,
  label = "Selecione uma progressão harmônica:",
  className = "text-white",
}) {
  const resolvedOptions =
    options ||
    graus
      .filter((numero) => numero !== 0)
      .map((numero) => ({
        label: numero.join(","),
        value: numero.join(","),
      }));

  return (
    <div className="boxCampo">
      <label className={className}>{label}</label>
      <select className="inputSeletor bg-slate-200" onChange={(e) => onChange(e.target.value)}>
        {resolvedOptions.map((option, key) => (
          <option className="text-slate-900" key={key} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
